import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { setContext } from '@apollo/client/link/context';
import { getToken } from '@upshow/auth';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import packageInfo from '../../../package.json';
const { version } = packageInfo;

const link = new BatchHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_URL,
    batchMax: 5, // No more than 5 operations per batch
    batchInterval: 20 // Wait no more than 20ms after first batched operation
});

const authLink = setContext(async (_, { headers }) => {
    const accessToken = await getToken();
    const auth = `Bearer ${accessToken}`;
    return {
        headers: {
            ...headers,
            Authorization: auth,
            'X-App-Version': version
        }
    };
});

const client = new ApolloClient({
    link: authLink.concat(link),
    cache: new InMemoryCache({
        possibleTypes: {
            LiveEvent: [],
            EntertainmentFeed: [
                'UpshowNowChannel',
                'Application',
                'PlutoTvChannel',
                'LiveEvent',
                'MediaChannel',
                'UpshowGame'
            ]
        }
    })
});

export { client };
